import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Demo-mode state — a tiny Zustand store the AppShell reads to decide
 * whether to mount the floating DemoPlayer overlay.
 *
 * Why a global store instead of `<Route path="/demo">`:
 *   The DemoPlayer's whole purpose is to NAVIGATE the router on a timer.
 *   If it lives inside a route element it unmounts the moment it
 *   navigates to step 1. So instead, it's lifted into the AppShell where
 *   it persists across every route change, gated by this store.
 *
 * Persisted to sessionStorage so a hard reload mid-demo recovers cleanly
 * (we don't want a refresh to drop someone out of demo mode silently).
 */

interface DemoState {
  active: boolean;
  start: () => void;
  stop: () => void;
}

export const useDemoMode = create<DemoState>()(
  persist(
    (set) => ({
      active: false,
      start: () => set({ active: true }),
      stop: () => set({ active: false }),
    }),
    {
      name: 'ga-demo-mode',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
